import { History } from "lucide-react";
import { changeEventConfig, describeChangeEventDetails } from "~/lib/change-events";
import { formatDate } from "~/lib/format";
import type { CompanyChangeEvent } from "~/types/company";
import { CardFooterLink, OverviewCard } from "./card";

/** ⑤ Poslední změny — compact teaser of the newest change events. */
export function ChangesCard({ changes }: { changes: CompanyChangeEvent[] | null }) {
	if (!changes || changes.length === 0) return null;

	return (
		<OverviewCard icon={History} title="Poslední změny" hue="rose">
			<ul className="flex flex-col gap-2.5">
				{changes.slice(0, 5).map((event) => {
					const config = changeEventConfig(event.eventType);
					const detail = describeChangeEventDetails(event);
					return (
						<li key={event.id} className="flex items-baseline gap-3 text-sm">
							<span className="shrink-0 font-mono text-xs text-muted-foreground tabular-nums w-20">
								{formatDate(event.detectedAt)}
							</span>
							<span className="min-w-0">
								<span className="font-medium">{config.label}</span>
								{detail && <span className="text-muted-foreground"> — {detail}</span>}
							</span>
						</li>
					);
				})}
			</ul>
			<CardFooterLink to="historie">Celá historie</CardFooterLink>
		</OverviewCard>
	);
}
